import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Loader2, Send } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const getAuthHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}` });

export const SendSurveyDialog = ({ form, onClose, onSent }) => {
  const [subject, setSubject] = useState(`${form.title} — we'd love your feedback`);
  const [message, setMessage] = useState(
    "Thank you for being part of this year's retreat. It meant a lot to have you there.\n\nWe'd be grateful for a few minutes of honest feedback — it directly shapes what we build for next year."
  );
  const [recipients, setRecipients] = useState('active');
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!subject.trim() || !message.trim()) { toast.error('Subject and message are required'); return; }
    if (!window.confirm(`Send this survey to ${recipients === 'active' ? 'all registered attendees' : 'everyone (incl. waitlist & cancelled)'}?`)) return;
    setSending(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/retreat/forms/${form.id}/send-survey`,
        { subject, message, recipient_type: recipients }, { headers: getAuthHeaders() });
      toast.success(res.data.message);
      onSent?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Send failed'); } finally { setSending(false); }
  };

  const link = `${window.location.origin}/survey/${form.id}`;

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="send-survey-dialog">
        <DialogHeader><DialogTitle>Send survey to participants</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Recipients</Label>
            <div className="flex gap-2 mt-1">
              {[['active', 'Registered attendees'], ['all', 'Everyone incl. waitlist & cancelled']].map(([k, l]) => (
                <button key={k} type="button" onClick={() => setRecipients(k)} data-testid={`survey-recipients-${k}`}
                  className={`px-3 py-1.5 text-xs font-medium rounded-md border transition-colors ${recipients === k ? 'bg-wine text-white border-wine' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}>{l}</button>
              ))}
            </div>
          </div>
          <div><Label>Subject</Label><Input value={subject} onChange={e => setSubject(e.target.value)} data-testid="survey-subject" /></div>
          <div><Label>Message</Label><Textarea rows={6} value={message} onChange={e => setMessage(e.target.value)} data-testid="survey-message" /></div>
          <p className="text-xs text-gray-500">The survey link is added automatically: <span className="font-mono break-all">{link}</span></p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={send} disabled={sending} className="bg-gradient-to-r from-wine to-burgundy text-white" data-testid="survey-send-btn">
            {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}Send survey
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
